import {
  AfterViewInit,
  Component,
  computed,
  effect,
  inject,
  Injector,
  input,
  model,
  output,
  signal,
  viewChild,
} from '@angular/core';

import { SitesQuery } from '@models/sites/sites.query';

import { ButtonComponent } from '@shared/components/button/button.component';
import { MultiCheckboxSelectComponent } from '@shared/components/multi-checkbox-select-dropdown/multi-checkbox-select-dropdown.component';
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive';
import { EnhancedOption } from '@shared/types/components.type';
import { Utils } from '@shared/utils/utils';

@Component({
  imports: [MultiCheckboxSelectComponent, ButtonComponent, ClickOutsideDirective],
  selector: 'aux-multiple-site-select',
  styles: [
    `
      :host ::ng-deep .multi-vendor-select {
        .ng-dropdown-panel {
          width: auto !important;
          max-width: 550px;
          min-width: 100%;
          max-height: 400px; /* to fix double scrollbar increased default menu height */
        }
      }
    `,
  ],
  templateUrl: './multiple-site-select.component.html',
})
export class MultipleSiteSelectComponent implements AfterViewInit {
  injector = inject(Injector);
  sitesQuery = inject(SitesQuery);

  viewSiteIDs = signal<string[]>([]);

  options = computed(() => {
    return this.sitesQuery
      .selectSiteOptions()()
      .map((item) => {
        return {
          label: item.title,
          subLabel: item.subTitle,
          value: item.value,
        } as EnhancedOption;
      });
  });
  sortedSites = computed(() => {
    return (this.sitesQuery.sites() || []).sort(({ site_no }, { site_no: site_no2 }) =>
      Utils.localeAlphaNumSort(site_no || '', site_no2 || '')
    );
  });

  appliedSelectedSiteIDs = model<string[]>([]);

  applySelectionOnButton = input<boolean>(true);
  itemsToDisplay = input<number>(2);

  applySelection = output<string[]>();

  multiCheckboxSelect = viewChild<MultiCheckboxSelectComponent>('multiCheckboxSelect');

  _setInitialValue = effect(() => {
    if (this.sortedSites().length) {
      this.viewSiteIDs.set([this.sortedSites()[0].id]);
    }
  });

  ngAfterViewInit(): void {
    effect(
      () => {
        if (!this.applySelectionOnButton()) {
          this.applyChanges(this.viewSiteIDs());
        }
      },
      { injector: this.injector }
    );
  }

  applyChanges(sites: string[]) {
    this.appliedSelectedSiteIDs.set(sites);
    this.applySelection.emit(sites);

    if (this.applySelectionOnButton()) {
      this.multiCheckboxSelect()?.select()?.close();
    }
  }

  closeOnSelect() {
    // reset selected sites in ui
    this.viewSiteIDs.set(this.appliedSelectedSiteIDs());
  }
}
